import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=a081a78a&scoped=true"
import script from "./TemplateList.vue?vue&type=script&lang=js"
export * from "./TemplateList.vue?vue&type=script&lang=js"
import style0 from "./TemplateList.vue?vue&type=style&index=0&id=a081a78a&prod&lang=scss&scoped=true"
import style1 from "./TemplateList.vue?vue&type=style&index=1&id=a081a78a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a081a78a",
  null
  
)

export default component.exports